define('../app/fukit/view/block/two.column.right.rail.layout.view',['require','exports','module','uikit/uikit','../../helpers/extend.util','../common/page.header.view','templates','./vertically.spaced.components.container.view'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                                   = require('uikit/uikit'),
      ExtendUtil                              = require('../../helpers/extend.util'),
      PageHeaderView                          = require('../common/page.header.view'),
      Templates                               = require('templates'),
      VerticallySpacedComponentsContainerView = require('./vertically.spaced.components.container.view');


  var TwoColumnRightRailLayoutView = UIKit.ItemView.extend({

    className: 'page',

    template: Templates.App['two.column.right.rail.layout'],

    internalViewOptions: {
      pageHeaderView: ExtendUtil.extendOptionValueWithDefaults('pageHeader', {
        type: PageHeaderView
      }),
      contentColumnView: ExtendUtil.extendOptionValueWithDefaults('contentColumn', {
        type: VerticallySpacedComponentsContainerView
      }),
      railColumnView: ExtendUtil.extendOptionValueWithDefaults('railColumn', {
        type: VerticallySpacedComponentsContainerView
      })
    }

  });

  module.exports = TwoColumnRightRailLayoutView;
});

